<template>

  <t-page>

    <t-page-form card command="view"
                 go-back-path="general/my-report"
                 go-back-title="Meus Relatórios"
                 :title="'Download de Relatório Avançado'">

      <div>

        <b-row v-for="file in files" :key="file.orderList" class="mb-2 d-flex align-content-center justify-content-center">

          <t-button
              @click="downloadReport(file)" large style="min-width: 300px;">
            <b-icon-file-pdf v-if="report.extension === 'pdf'"></b-icon-file-pdf>
            <b-icon-file-word
                v-if="report.extension === 'doc' || report.extension === 'docx'"></b-icon-file-word>
            <b-icon-file-excel
                v-if="report.extension === 'xls' || report.extension === 'xlsx'"></b-icon-file-excel>
            {{ file.publicFileName }}
          </t-button>

        </b-row>

      </div>



    </t-page-form>



  </t-page>

</template>

<script>

import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import {crudGeneral} from "@/services/resource/GeneralCRUD.service";
import pageFormMixin from "@/mixins/page/pageFormMixin";
import http from "@/services/config/http-common";
import ui from "@/assets/scripts/ui";
export default {
  mixins: [pageDefaultMixin, pageFormMixin],
  name: 'MyReportItem',
  data() {
    return {
      path: "general/report/my-report-by-part", //Utilizar somente quando fora do padrão
      generalResource: true, //Página de recurso geral
      genKey: false, //Utilizar quando desejar gerar chave temporária
      fieldKey: "",
      pageTitle: "Meus Relatórios Avançados",
      form:{
        name:"",
      },
      error: {//Campos que podem receber retorno de erro do backend
        name: "",
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      report: {},
      files: [],

      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {

    },
    async mountedContinued() {

      await crudGeneral.get(this.path + "/" + this.$route.params.id).then(async (report) => {

        this.report = report.data

        await crudGeneral.get(this.path + "/files/" + this.$route.params.id).then((items) => {
          this.files = items.data
        }).catch(error => ui.generalResponseError(this,error))


      }).catch(error => ui.generalResponseError(this,error,()=>{
        this.go('my-report')
      }))

      this.pageFormIsLoaded = true


    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela

    async downloadReport(file){

      await http.download(this.path + "/download/" + this.report.reportByPartId + "/" + file.orderList, file.publicFileName)
          .catch(error => ui.generalResponseError(this,error))


    }
    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedForm(false, true)

    await this.mountedContinued()

  },

}
</script>
